import { Heading, type TypographyHeadingProps } from './src/Heading';
import { Subheading, type TypographySubheadingProps } from './src/Subheading';
import { Body, type TypographyBodyProps } from './src/Body';
import { Caption, type TypographyCaptionProps } from './src/Caption';
import { ComponentType } from 'react';

export const Typography: {
  Heading: ComponentType<TypographyHeadingProps>;
  Subheading: ComponentType<TypographySubheadingProps>;
  Body: ComponentType<TypographyBodyProps>;
  Caption: ComponentType<TypographyCaptionProps>;
} = {
  Heading,
  Subheading,
  Body,
  Caption,
};

export type {
  TypographyHeadingProps,
  TypographySubheadingProps,
  TypographyBodyProps,
  TypographyCaptionProps,
};
